/* SHARED VARS */
var touch = false,
    clickEv = 'click';


/* Fucntion get width browser */
function getWidthBrowser() {
	var myWidth;

	if( typeof( window.innerWidth ) == 'number' ) { 
		//Non-IE 
		myWidth = window.innerWidth;
	} 
	else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) { 
		//IE 6+ in 'standards compliant mode' 
		myWidth = document.documentElement.clientWidth; 
	} 
	else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) { 
		//IE 4 compatible 
		myWidth = document.body.clientWidth; 
	}
	
	return myWidth;
}

/* Fucntion get height browser */
function getHeightBrowser() {
	var myHeight;

	if( typeof( window.innerHeight ) == 'number' ) { 
		//Non-IE 
		myHeight = window.innerHeight; 
	} 
	else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) { 
		//IE 6+ in 'standards compliant mode' 
		myHeight = document.documentElement.clientHeight;
	} 
	else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) { 
		//IE 4 compatible 
		myHeight = document.body.clientHeight;
	}
	
	return myHeight;
}

/* Function: Create main content width */
function setMainWidth(){
  
  var sideWidth = $('#menu-container').outerWidth();
  var contentWidth = getWidthBrowser() - sideWidth;
  
  $('#module-container').css({'width': contentWidth + 'px', 'left': sideWidth + 'px'});
}

/* Function: Create main content height */
function setContentHeight(){
  
  var headerHeight = $('#header').outerHeight();
  var contentHeight = getHeightBrowser() - headerHeight;
  
  $('#module-content').css({'height': contentHeight + 'px'});
}


// handles scroll-to-top button
function handleScrollToTopButton() {
  
  function totop_button(a) {
    var b = $("#scroll-to-top");
    b.removeClass("off on");
    if (a == "on") { b.addClass("on") } else { b.addClass("off") }
  }
  
  $('#module-content').scroll(function() {
    var b = $(this).scrollTop();
    var c = $(this).height();
    if (b > 0) { 
      var d = b + c / 2;
    } 
    else { 
      var d = 1 ;
    }
    
    if (d < 1e3) { 
      totop_button("off");
    } 
    else { 
      totop_button("on"); 
    }
  });
  
  $("#scroll-to-top").click(function (e) {
    e.preventDefault();
    $('#module-content').animate({scrollTop:0},800,'swing');
  });
}


/* Function update slideshow */
function updateSlider(){
  if($('#home-slider').length){
    var data = $('#home-slider').data('slider');
    if(data){
      data.resize();
    }
  }
}

/* Function update carousel */
function updateCarousel(){
  if($('#home-slider').length){
    var data = $('#home-slider').data('slider');
    if(data){
      data.resize();
    }
  }
}

/* Function update after change width */
function updateCallback() {
  /* Update scrollbar product images thumb */
  if($('.product-image-thumb').length){
    $('.product-image-thumb').mCustomScrollbar('update');
  }
  
  /*  Update scrollbar related products*/
  if($('#product-related').length){
    
      $('#product-related').resize();
    
  }
  
  /*  Update scrollbar featured collection*/
  if($('#featured-collection').length){
    
      $('#featured-collection').resize();
    
  }
  
  /* Update main slideshow */
  updateSlider();
}

/* Function: Refresh Zoom */
function alwaysUpdateZoom(){
  if(touch == false){
    
    if($('.elevatezoom').length){
      
      var zoomImage = $('.elevatezoom .img-zoom');

      zoomImage.elevateZoom({
        gallery:'gallery_main', 
        galleryActiveClass: 'active', 
        zoomType: 'window',
        cursor: 'pointer',
        zoomWindowFadeIn: 300,
        zoomWindowFadeOut: 300,
        scrollZoom: true,
        easing : true,
        loadingIcon: '//cdn.shopify.com/s/files/1/1230/2130/t/7/assets/loader.gif?v=147071982126738704471460303460'
      });
      
      
    }
    
  }
}

/* Function update scroll product thumbs */
function updateScrollThumbs(){
  if($('#gallery_main').length){

    $('#product-image').on(clickEv, '.image-thumb', function() {

      var $this = $(this);
      var background = $('.product-image .main-image .main-image-bg');
      var parent = $this.parents('.product-image-wrapper');
      var src_original = $this.attr('data-image-zoom');
      var src_display = $this.attr('data-image');
      
      background.show();
      
      parent.find('.image-thumb').removeClass('active');
      $this.addClass('active');
      
      parent.find('.main-image').find('img').attr('data-zoom-image', src_original);
      parent.find('.main-image').find('img').attr('src', src_display).load(function() {
        background.hide();
      });
      
      return false;
    });
  }
}

/* Function: Refresh CloudZoom Quick Shop */
function alwaysUpdateZoomQS(){
  if(touch == false){
    
    if($('.elevatezoom_qs').length){
      
      var zoomImage = $('.elevatezoom_qs .img-zoom');
      
      // Reinitialize EZ
      zoomImage.elevateZoom({
        gallery:'gallery_main_qs', 
        galleryActiveClass: 'active', 
        zoomType: 'window',
        cursor: 'pointer',
        zoomWindowFadeIn: 300,
        zoomWindowFadeOut: 300,
        scrollZoom: true,
        easing : true,
        loadingIcon: '//cdn.shopify.com/s/files/1/1230/2130/t/7/assets/loader.gif?v=147071982126738704471460303460'
      });
      
      
    }
    
  }
}
      
/* Function update scroll product thumbs quickshop */
function updateScrollThumbsQS(){
  if($('#gallery_main_qs').length){

    $('#quick-shop-image').on(clickEv, '.image-thumb', function() {

      var $this = $(this);
      var background = $('.product-image .main-image .main-image-bg');
      var parent = $this.parents('.product-image-wrapper');
      var src_original = $this.attr('data-image-zoom');
      var src_display = $this.attr('data-image');
      
      background.show();
      
      parent.find('.image-thumb').removeClass('active');
      $this.addClass('active');
      
      parent.find('.main-image').find('img').attr('data-zoom-image', src_original);
      parent.find('.main-image').find('img').attr('src', src_display).load(function() {
        background.hide();
      });
      
      return false;
    });
  }
}

function initDocumentReady(){
  
  /* DETECT PLATFORM */
  $.support.touch = 'ontouchend' in document;
  
  if ($.support.touch) {
    touch = true;
    $('body').addClass('touch');
    clickEv = 'touchstart';
  };
  
  // callback after images loaded
  callbackImagesLoaded();
  
  /* Dropdown don't close after click */
  $('.noclose').click(function (e) {
    e.stopPropagation();
  });
  
  /* Home slideshow */
  if($('#home-slider').length){
    $('#home-slider').responsiveSlider({
      autoplay: true,
      interval: 5000,
      transitionTime: 300
    });
  }
  
  /* GMap */
  if(jQuery().gMap){
    $('#contact_map').gMap({
      zoom: 17,
      scrollwheel: true,
      maptype: 'ROADMAP',
      markers:[
        {
          address: '',
          html: '_address',
          icon: {
            image: '//cdn.shopify.com/s/files/1/1230/2130/t/7/assets/icon-gmap.png?v=127691104029315296431460303457',
            iconsize: [188, 68],
            iconanchor: [0,68]
          }
        }
      ]
    });
  }
  
  handleScrollToTopButton();
  
  
  /* # Scroll Main */
  if(touch == false){
    $('#module-content').niceScroll({
      cursorwidth: '10px',
      cursorcolor: '#cf2411',
      cursorborder: 'none',
      cursorborderradius: '0',
      horizrailenabled: false, 
      cursoropacitymin: '0.5',
      styler: "fb"
    });
    
    $('.nicescroll-rails').css('visibility', 'hidden');
  } 
  
  
  /* Cloud Zoom in Product page */
  alwaysUpdateZoom();
  
  
  /* # Scroll Related Products */
  if($('#product-related').length){
    $('#product-related').hide();
  }
  
  
  /* # Scroll Featured Collection */
  if($('#featured-collection').length){
    $('#featured-collection').hide();
  }
  
  
  /* # Init fancybox for product image */
  if($('.product-fancybox-buttons').length){
    $('.product-fancybox-buttons').fancybox({
      closeBtn  : false,
      helpers : {
        buttons	: {}
      }
    });
  }
}

function initWindowLoad(){
  // to do
}
     
function callbackImagesLoaded(){
  
  /* # Scroll Product Thumbs */
  if($('.product-image-thumb').length){
    imagesLoaded( '.product-image-thumb', function() {
      $('.product-image-thumb').show();
      
      $('.product-image-thumb').mCustomScrollbar({
        horizontalScroll:true,
        scrollInertia:100
      });
    });
  }
  
  /* # Scroll Related Products */
  if($('#product-related').length){
    imagesLoaded( '#product-related', function() {
      $('#product-related').show();
      
      
      $("#product-related").owlCarousel({
        navigation : true,
        pagination: false,
        items: 3,
        itemsDesktop : [1199,3],
        itemsDesktopSmall : [979,2],
        itemsTablet: [768,2],
        itemsMobile : [479,1],
        scrollPerPage: true,
        navigationText: ['<span class="btn btn-1 mini"><i class="icon-chevron-left"></i></span>', '<span class="btn btn-1 mini"><i class="icon-chevron-right"></i></span>']
      });
      
    });
  }
       
       
  /* # Scroll Featured Collection */
  if($('#featured-collection').length){
    imagesLoaded( '#featured-collection', function() {
      $('#featured-collection').show();
      
      
      $("#featured-collection").owlCarousel({
        navigation : true,
        pagination: false,
        items: 3,
        itemsDesktop : [1199,3],
        itemsDesktopSmall : [979,2],
        itemsTablet: [768,2],
        itemsMobile : [479,1],
        scrollPerPage: true,
		navigationText: ['<span class="btn btn-1 mini"><i class="icon-chevron-left"></i></span>', '<span class="btn btn-1 mini"><i class="icon-chevron-right"></i></span>']
       });
      
    });
  }  
                 
  /* Visible Body Content */
  imagesLoaded( '#col-main', function() {
   var delayLoading = '';       
   delayLoading = setInterval(function(){            
     
     $('#loading-loader').hide();
     
     $('.nicescroll-rails').css('visibility', 'visible');
     
     clearInterval( delayLoading );            
   }, 500);
  });
}

$(window).load(function() {
  
  initWindowLoad();
  
});

$(window).resize(function() {
  
  // Menu and Content
  alwaysUpdate();

});


jQuery(document).ready(function($) {
  
  initDocumentReady();
  
  if($("img.unveil").length)
  $("img.unveil").unveil(300);
  
  
  /* Tooltip */
  $('.btooltip').tooltip();
});